/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactWithRelations } from '../../models/contact-with-relations';

export interface GetInventoryContacts$Params {
  inventoryId: string;
  roleCodes?: Array<string>;
}

export function getInventoryContacts(http: HttpClient, rootUrl: string, params: GetInventoryContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getInventoryContacts.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
    rb.query('roleCodes', params.roleCodes, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactWithRelations>>;
    })
  );
}

getInventoryContacts.PATH = '/inventories/contacts';
